import { render, staticRenderFns } from "./promotionalBeltTemp.vue?vue&type=template&id=09b2d40f&scoped=true&"
import script from "./promotionalBeltTemp.vue?vue&type=script&lang=js&"
export * from "./promotionalBeltTemp.vue?vue&type=script&lang=js&"
import style0 from "./promotionalBeltTemp.vue?vue&type=style&index=0&lang=css&"
import style1 from "./promotionalBeltTemp.vue?vue&type=style&index=1&id=09b2d40f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09b2d40f",
  null
  
)

component.options.__file = "promotionalBeltTemp.vue"
export default component.exports